import { ResourceDetails } from '../common';

export enum AsgAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type AsgActionType =
  | AsgAction.START
  | AsgAction.STOP
  | AsgAction.RESTART;

export enum AsgState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface AsgResourceDetails extends ResourceDetails {
  desired: number;
  min: number;
  max: number;
  instanceCount: number;
  status: AsgState;
}
